import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import 'common/css/master.css';
import "../css/studentFeeDetails.css";
import Popup from './Popup.js'
import StudentFeeDiscountBreakdown from './studentFeeDiscountBreakdown.jsx';

import { getStudentFeeDtlsSvc, saveStudentFeeDtlsSvc, removeDiscountSvc } from "./studentFeeDetailsDiscountSvc";

const StudentFeeDetails = (props) => {
  const { studentId, closeDiscountSlider } = props;
  const [lstDiscount, setLstDiscount] = useState([]);
  const [loader, setLoader] = useState("none");
  const [opacity, setOpacity] = useState(1);
  const [lstSaveDiscount, setLstSaveDiscount] = useState([]);
  const [feeStudentId, setFeeStudentId] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [wId, setWId] = useState(0)
  const [discountData, setDiscountData] = useState({})
  const [studentName, setStudentName] = useState(props.studentName);
  const [totalFees, setTotalFees] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalNetFee, setTotalNetFee] = useState(0);
  const [totalPaidFee, setTotalPaidFee] = useState(0);
  const [totalFeeBalance, setTotalFeeBalance] = useState(0);
  const [keySummary, setKeySummary] = useState(0);
  const [flgDiscountUpdated, setFlgDiscountUpdated] = useState(0)
  const [discRow, setDiscRow] = useState({})
  const month = [
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];

  useEffect(() => {
    setLstDiscount(props.lstDiscount)
    calcFeeDiscountSummary(props.lstDiscount);
  }, [props.keySummary]);

  useEffect(() => {
    if (studentId !== 0) {
      setStudentFeeDetailsTable();
    }
    // setFeeDiscountSummary();
  }, [studentId]);

  const setStudentFeeDetailsTable = () => {
    setLoader("block");
    setOpacity(0.5);
    console.log('studentId', studentId)
    getStudentFeeDtlsSvc(studentId, discountTableResponse);
  };

  const discountTableResponse = (data) => {
    var obj = data;
    if (obj.status === "Success") {
      toast.success(obj.message);
      setLstDiscount(obj.lstDiscount);
      calcFeeDiscountSummary(obj.lstDiscount)
    } else {
      toast.error(obj.message);
    }
    setLoader("none");
    setOpacity(1);
  };

  const removeDiscounts = () => {
    var tmpLstWaiverId = [];
    lstDiscount.map((discountRow) => {
      tmpLstWaiverId.push(discountRow.waiverId);
    });
    removeDiscountSvc(tmpLstWaiverId, removeDiscountResponse);
  };

  const removeDiscountResponse = (data) => {
    var obj = data;
    if (obj.status === "Success") {
      toast.success(obj.message);
      setStudentFeeDetailsTable();
    } else {
      toast.error(obj.message);
    }
    setLoader("none");
    setOpacity(1);
  };

  const saveDiscount = () => {
    setLoader("block");
    setOpacity(0.5);
    var tmpLstSaveData = [];

    lstDiscount.map((discountRow) => {
      const lstNewDiscount = discountRow.lstDiscount.filter(({ amt }) => amt !== 0).map(item => ({
        remarks: item.remarks,
        amt: item.amt,
        discountId: item.discountId
      }));
      const updatedDiscount = {
        monthId: discountRow.monthId,
        totalFees: discountRow.totalFees,
        discountId: discountRow.discountId,
        discountAmt: discountRow.discountAmt,
        flgLateFee: discountRow.flgLateFee,
        remarks: discountRow.remarks,
        feeStudentId: discountRow.feeStudentId,
        headId: discountRow.feeHeadId,
        lstDiscount: lstNewDiscount
      };
      tmpLstSaveData.push(updatedDiscount);
    });
    setLstSaveDiscount(tmpLstSaveData);
    saveStudentFeeDtlsSvc(studentId, tmpLstSaveData, saveDiscountResponse);
  };

  const saveDiscountResponse = (data) => {
    var obj = data;
    if (obj.status === "Success") {
      toast.success(obj.message);
      setStudentFeeDetailsTable();
    } else {
      toast.error(obj.message);
    }
    setLoader("none");
    setOpacity(1);
  }

  const updateRemark = (wId, e) => {
    var tmpLstDiscount = [...lstDiscount];
    for (var i = 0; i < tmpLstDiscount.length; i++) {
      if (tmpLstDiscount[i].waiverId === wId) {
        tmpLstDiscount[i] = { ...tmpLstDiscount[i], remarks: e.target.value };
        break;
      }
    }
    setLstDiscount(tmpLstDiscount);
  };

  const updateFlgLateFee = (wId, e) => {
    var tmpLstDiscount = [...lstDiscount];
    for (var i = 0; i < tmpLstDiscount.length; i++) {
      if (tmpLstDiscount[i].waiverId === wId) {
        tmpLstDiscount[i] = {
          ...tmpLstDiscount[i],
          flgLateFee: !tmpLstDiscount[i].flgLateFee,
        };
        break;
      }
    }
    setLstDiscount(tmpLstDiscount);
  };

  const updatedDiscountType = (e, mnthId) => {
    var tmpLstDiscount = [...lstDiscount];
    for (var i = 0; i < tmpLstDiscount.length; i++) {
      if (tmpLstDiscount[i].monthId === mnthId) {
        tmpLstDiscount[i] = {
          ...tmpLstDiscount[i],
          discountId: e.target.value,
        };
        break;
      }
    }
    setLstDiscount(tmpLstDiscount);
  };

  const updateDiscountAmount = async (wId, lstData, tot) => {
    console.log('updateDiscountAmount.. ', wId, lstData, tot)
    var tmpLstDiscount = [...lstDiscount];
    console.log('lstTmpDiscount:', tmpLstDiscount)
    for (var i = 0; i < tmpLstDiscount.length; i++) {
      if (tmpLstDiscount[i].waiverId === wId) {
        tmpLstDiscount[i] = {
          ...tmpLstDiscount[i],
          lstDiscount: lstData,
          discountAmt: tot
        };
        break;
      }
    }
    console.log(tmpLstDiscount)
    await setLstDiscount(tmpLstDiscount)
    setKeySummary(keySummary + 1)
    calcFeeDiscountSummary(tmpLstDiscount);
  };

  const closePopup = () => {
    setShowPopup(false);
    document.querySelector("body").classList.remove("showPopup");
  }

  /* const setFeeDiscountSummary = () => {
    let tFee = 0;
    let tDisc = 0;
    let tPaid = 0;
    if (lstDiscount) {
      lstDiscount.map((discountRow) => {
        tFee = tFee + discountRow.totalFees;
        tDisc = tDisc + Number(discountRow.discountAmt);
        tPaid = tPaid + discountRow.paidAmt;
      });
    }
    setTotalFees(tFee);
    setTotalDiscount(tDisc);
    setTotalNetFee(tFee - tDisc);
    setTotalPaidFee(tPaid);
    setTotalFeeBalance(tFee - tDisc - tPaid);
  } */

  const calcFeeDiscountSummary = (pLstDiscount) => {
    console.log('calcFeeDiscountSummary() called..', pLstDiscount);
    let tFee = 0;
    let tDisc = 0;
    let tPaid = 0;
    if (pLstDiscount) {
      pLstDiscount.map((discountRow) => {
        tFee = tFee + discountRow.totalFees;
        tDisc = tDisc + Number(discountRow.discountAmt);
        tPaid = tPaid + discountRow.paidAmt;
      });
    }
    console.log('summary = ', tFee, tDisc, tPaid, tFee - tDisc, tFee - tDisc - tPaid)
    setTotalFees(tFee);
    setTotalDiscount(tDisc);
    setTotalNetFee(tFee - tDisc);
    setTotalPaidFee(tPaid);
    setTotalFeeBalance(tFee - tDisc - tPaid);
  }

  return (
    <div>
      <ToastContainer autoClose={3000} hideProgressBar />
      <div style={{ width: "100%", textAlign: "center", margin: 0 }}>
        <button
          type="button"
          className="btn btn-info text-center "
          style={{ right: "80%" }}
          id="closeSlider"
          onClick={props.closeSlider}
        >
          <span
            id="close"
            title="Close Slider"
            className="glyphicon glyphicon-remove"
          ></span>
        </button>

        <div className="col-sm-12 padding-remove" style={{ marginTop: 5, marginBottom: 5 }}>
          <div className="col-sm-2 padding-remove ">
            <label className=" col-sm-12 text-left padding-remove" style={{ fontWeight: "bold", paddingLeft: 10 }}>
              {studentName}
            </label>
          </div>
          <div className="col-sm-10 padding-remove ">
            <div className="col-sm-2 padding-remove ">
            </div>
            <div className="col-sm-2 padding-remove ">
              <div
                className="col-sm-12 padding-remove pull-right "
                style={{ border: "1px solid #ccc", borderRadius: "4px" }}
              >
                <label className=" col-sm-12 text-left padding-remove ">
                  <span style={{ fontWeight: "bold", paddingLeft: 5 }}>
                    Total Fees:
                  </span>
                  <span style={{ fontWeight: 400, paddingLeft: 5 }}>
                    {totalFees.toLocaleString('en-IN')}
                  </span>
                </label>
              </div>
            </div>
            <div className="col-sm-2 padding-remove ">
              <div
                className="col-sm-11 padding-remove pull-right "
                style={{ border: "1px solid #ccc", borderRadius: "4px" }}
              >
                <label className=" col-sm-12 text-left padding-remove">
                  <span style={{ fontWeight: "bold", paddingLeft: 5 }}>
                    Discount:
                  </span>
                  <span style={{ fontWeight: 400, paddingLeft: 5 }}>
                    {totalDiscount.toLocaleString('en-IN')}
                  </span>
                </label>
              </div>
            </div>
            <div className="col-sm-2 padding-remove ">
              <div
                className="col-sm-11 padding-remove pull-right "
                style={{ border: "1px solid #ccc", borderRadius: "4px" }}
              >
                <label className=" col-sm-12 text-left padding-remove">
                  <span style={{ fontWeight: "bold", paddingLeft: 5 }}>
                    Net Fees:
                  </span>
                  <span style={{ fontWeight: 400, paddingLeft: 5 }}>
                    {totalNetFee.toLocaleString('en-IN')}
                  </span>
                </label>
              </div>
            </div>
            <div className="col-sm-2 padding-remove ">
              <div
                className="col-sm-11 padding-remove pull-right "
                style={{ border: "1px solid #ccc", borderRadius: "4px" }}
              >
                <label className=" col-sm-12 text-left padding-remove ">
                  <span style={{ fontWeight: "bold", paddingLeft: 5 }}>
                    Paid:
                  </span>
                  <span style={{ fontWeight: 400, paddingLeft: 5 }}>
                    {totalPaidFee.toLocaleString('en-IN')}
                  </span>
                </label>
              </div>
            </div>
            <div className="col-sm-2 padding-remove ">
              <div
                className="col-sm-11 padding-remove pull-right "
                style={{ border: "1px solid #ccc", borderRadius: "4px" }}
              >
                <label className=" col-sm-12 text-left padding-remove">
                  <span style={{ fontWeight: "bold", paddingLeft: 5 }}>
                    Balance:
                  </span>
                  <span style={{ fontWeight: 400, paddingLeft: 5 }}>
                    {totalFeeBalance.toLocaleString('en-IN')}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div style={{ margin: 0, padding: 0 }}>
          <table>
            <thead>
              <tr>
                <th width="150">Month</th>
                <th style={{ display: 'none' }} width="150" >Fee Head Id</th>
                <th width="150">Fee Head</th>
                <th width="180">Total Fees</th>
                {/* <th width="300">Discount Type</th> */}
                <th width="180">Discount</th>
                <th width="100">Percent</th>
                <th width="180">Net Fees</th>
                <th width="100">Late Fee Waiver</th>
                <th width="180">Paid</th>
                <th width="450">Remarks</th>
              </tr>
            </thead>
            <tbody>
              {lstDiscount && lstDiscount.map((discountRow, index) => (
                <tr key={index} id={index}>
                  <td width="150">{discountRow.month}</td>
                  <td style={{ display: 'none' }} width="150">{discountRow.feeHeadId}</td>
                  <td width="150">{discountRow.feeHead}</td>
                  <td width="180">
                    {discountRow.totalFees.toLocaleString('en-IN')}
                  </td>
                  <td width="180" >
                    <input key={'damt_' + flgDiscountUpdated}
                      type="text"
                      className="form-control "
                      style={{
                        width: "80%",
                        marginLeft: "10%",
                        textAlign: "right",
                      }}
                      id="discountAmt"

                      defaultValue={
                        discountRow.discountAmt > 0
                          ? discountRow.discountAmt.toLocaleString('en-IN')
                          : ""
                      }
                      onChange={async () => {
                        await setDiscRow(discountRow)
                        await setWId(discountRow.waiverId)
                        await setDiscountData(discountRow.lstDiscount)
                        await setShowPopup(true);
                        await setKeySummary(keySummary + 1)
                        document.querySelector("body").classList.add("showPopup");
                      }}
                      placeholder="0"
                      onClick={async (e) => {
                        await setDiscRow(discountRow)
                        await setWId(discountRow.waiverId)
                        await setDiscountData(discountRow.lstDiscount)
                        await setShowPopup(true);
                        await setKeySummary(keySummary + 1)
                        document.querySelector("body").classList.add("showPopup");
                      }}
                    // disabled = {discountRow.totalFees - discountRow.paidAmt === 0}
                    />
                  </td>
                  <td width="100">
                    {discountRow.discountAmt > 0
                      ? (
                        (discountRow.discountAmt * 100) /
                        discountRow.totalFees
                      ).toFixed(2) + "%"
                      : "-"}
                  </td>
                  <td width="180">
                    {(discountRow.totalFees - discountRow.discountAmt).toLocaleString('en-IN')}
                  </td>
                  <td width="100">
                    <input
                      type="checkbox"
                      defaultChecked={discountRow.flgLateFee}
                      onClick={(e) => updateFlgLateFee(discountRow.waiverId, e)}
                    />
                  </td>
                  <td width="180">{discountRow.paidAmt}</td>
                  <td width="450">
                    <textarea
                      className="form-control"
                      style={{ margin: "5px 5%", width: "90%", height: 35 }}
                      defaultValue={discountRow.remarks}
                      onChange={(e) => updateRemark(discountRow.waiverId, e)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div
          style={{
            marginTop: 20,
            marginRight: 40,
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div>
            <div className="col-sm-12 text-center pull-right">
              <button
                type="button"
                style={{
                  width: 100,
                  backgroundColor: "#48a2bc",
                  padding: "3px 12px",
                  fontSize: 16,
                }}
                title="Save"
                onClick={saveDiscount}
                className="btn btn-info"
              >
                Save
              </button>
            </div>
          </div>
          <div>
            <a className="discountTd" onClick={removeDiscounts}>
              remove all discount
            </a>
          </div>
        </div>
      </div>
      {discountData.length && (
        <div className='popup' style={{ width: 600 }}>
          {showPopup && (
            <Popup
              key={'key_s_' + studentId + '_w_' + wId}
              open={showPopup}
              closePopup={closePopup}
              onClose={() => {
                setShowPopup(false);
                document.querySelector("body").classList.remove("showPopup");
              }}
              title="Discount"
            >
              <StudentFeeDiscountBreakdown
                key={'s_dis_' + studentId + '_w_' + wId}
                wId={wId}
                discRow={discRow}
                setDiscRow={setDiscRow}
                studentId={studentId}
                studentName={studentName}
                feeStudentId={feeStudentId}
                closePopup={closePopup}
                discountData={discountData}
                setFlgDiscountUpdated={setFlgDiscountUpdated}
                // setDiscRow={(data) => this.setState({ discRow: data })}
                updateDiscountAmount={updateDiscountAmount}

              />
            </Popup>
          )}
        </div>
      )}
    </div>
  );
};

export default StudentFeeDetails;
